import { styled, css } from 'styled-components';
import { verticalFadeIn, verticalFadeOut } from '../../theme/animations';
import { ANIMATION_DURATION_MS } from './constants';
export const Wrapper = styled.div `
  ${({ theme }) => theme.shadows.large};
  padding: 5px 0;
  list-style: none;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.grey00_6};
  z-index: ${({ zIndex }) => zIndex};
  min-width: ${({ minWidth }) => minWidth && '160px'};
  animation: ${({ visible, isTop }) => (visible ? verticalFadeIn(isTop) : verticalFadeOut(isTop))} ${ANIMATION_DURATION_MS}ms ease forwards;

  ${({ trackHiddenReference }) => trackHiddenReference &&
    css `
      &[data-popper-reference-hidden='true'] {
        &,
        & * {
          visibility: hidden;
          pointer-events: none;
          transition: none;
        }
      }
    `}

  ${({ $maxHeight }) => $maxHeight &&
    css `
      max-height: ${$maxHeight}px;
      overflow: auto;
    `}
`;
export const ButtonWrapper = styled.div `
  display: inline-flex;
`;
export const ButtonComponent = styled.div `
  display: inline-flex;
`;
